var React = require('react');

function RightIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 16L14 12L10 8","stroke":"#00121A","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

RightIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = RightIcon;

RightIcon.default = RightIcon;
